// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"-name__-loca-__2JJW-","Logo":"-name__-loca-__1efBD","DesktopOnly":"-name__-loca-__WADUd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Toolbar/Toolbar.css
// module id = 155
// module chunks = 0